class InvalidPhoneError extends Error {}

export default (phone : string) : true => {
	// for appreview
	// return true;

	if (phone.substring(0, 2) === '09') { // 手機
		if (phone.length !== 10) {
			throw new InvalidPhoneError('手機長度不符')
		}

		if (!Number.isInteger(parseInt(phone))) {
			throw new InvalidPhoneError('手機號碼非數字')
		}

		return true
	} else if (phone.substring(0, 2) == '03' && phone.length == 9) {
		//宜蘭市話
		console.log('宜蘭市話')
		return true
	} else if (phone.length === 10) {
		return true
	}

	throw new InvalidPhoneError('市話長度不符')
}
